/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';

import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

import categorieArrowProduct from 'images/icons/arrows/categorieArrowProduct.svg';

import {
  ProductItem,
  ProductDescription,
  ProductCategorieSection,
  LinkWrapper
} from './style';

import ProductDialog from '../products/dialogs/ProductDialog/index';
import NotInNetworkProductDialog from '../notInNetworkProducts/dialogs/ProductDialog/index';

function ProductItemCategory({
  node,
  userInfo,
  refreshCategories,
  labelManagerHasAllPermissions
}) {
  const history = useHistory();
  const prevPath = history?.location?.state?.prevPath;
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';

  const [toastProps, setToastProps] = useState();
  const [toastOpen, setToastOpen] = useState(false);
  const [openProductTree, setOpenProductTree] = useState(false);
  const { id: paramsID, productId } = useParams();
  const [modalSettings, setModalSettings] = useState([
    {
      id: 1,
      name: 'productDialog',
      open: false
    }
  ]);

  const productDialogModal = modalSettings.find(
    (modal) => modal.name === 'productDialog'
  );

  const isNotInNetwork = !userLocal?.labelId;

  const shouldOpenProductDialog = productDialogModal?.open;

  const ProductDialogComponent = isNotInNetwork
    ? NotInNetworkProductDialog
    : ProductDialog;

  const handleCloseModal = () => {
    history.push(`/etiquetas/catalogo/categorias/${paramsID}`);
    setModalSettings((prev) =>
      prev.map((modal) =>
        modal.name === 'productDialog' ? { ...modal, open: false } : modal
      )
    );
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToastOpen(false);
  };

  return (
    <ProductItem openProductTree={openProductTree}>
      <section
        onClick={() => {
          setOpenProductTree(!openProductTree);
        }}
      >
        <div>
          {node?.products?.length}{' '}
          {node?.products?.length > 1 ? 'PRODUTOS' : 'PRODUTO'}
        </div>

        <div>
          <img src={categorieArrowProduct} alt="Arrow product" />
        </div>
      </section>
      {openProductTree &&
        node?.products?.map((product) => {
          return (
            <ProductDescription>
              <ProductCategorieSection>
                <LinkWrapper
                  onClick={() => {
                    history.push(
                      `/etiquetas/catalogo/categorias/${paramsID}/${product?.id}`
                    );
                    setModalSettings(
                      modalSettings.map((modal) =>
                        modal.name === 'productDialog'
                          ? { ...modal, open: true }
                          : modal
                      )
                    );
                  }}
                >
                  {product.description}
                </LinkWrapper>
              </ProductCategorieSection>
            </ProductDescription>
          );
        })}

      {shouldOpenProductDialog && (
        <ProductDialogComponent
          open={shouldOpenProductDialog}
          onClose={handleCloseModal}
          onlyView={!labelManagerHasAllPermissions && !isLabelAdmin}
          onSuccess={refreshCategories}
          originPage="categories"
        />
      )}

      <Snackbar
        open={toastOpen}
        onClose={handleCloseToast}
        autoHideDuration={2000}
      >
        <Alert onClose={handleCloseToast} severity={toastProps?.severity}>
          {toastProps?.message}
        </Alert>
      </Snackbar>
    </ProductItem>
  );
}

export default ProductItemCategory;
